import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

// Redux
import { connect } from 'react-redux';

// Redux Form
import { formValueSelector, change } from 'redux-form';
import { doRemoveLocation, startLocationUploaderLoader, endLocationUploaderLoader } from '../../../../actions/siteadmin/manageLocationImage';


// Translation
import { FormattedMessage, injectIntl } from 'react-intl';
import { locationuploadDir } from "../../../../config";
import { photosShow } from '../../../../helpers/photosShow';

// Asset
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay.js';

import cs from '../../../../components/commonStyle.css';
import s from './Uploader.css';
import messages from '../../../../locale/jsonMessages';
class Uploader extends React.Component {

  static propTypes = {
    image: PropTypes.any,
    locationUploaderLoading: PropTypes.bool,
    doRemoveLocation: PropTypes.any.isRequired,
    startLocationUploaderLoader: PropTypes.any.isRequired,
    endLocationUploaderLoader: PropTypes.any.isRequired,
  };

  static defaultProps = {
    locationUploaderLoading: false,
  };

  success = async (file, fromServer) => {
    const { doUploadLocation, change, startLocationUploaderLoader, endLocationUploaderLoader } = this.props;
    let fileName = fromServer.file.filename;
    startLocationUploaderLoader();
    await change('AddPopularLocation', 'image', fileName);
    endLocationUploaderLoader();
  }

  render() {
    const { loading, locationUploaderLoading, image } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(locationuploadDir);

    return (
      <div>
        <CommonImageDisplay
          loading={loading}
          loader={locationUploaderLoading}
          isDefaultPic={image ? false : true}
          isDelete={false}
          image={image && path + image}
        />

        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadLocation'
          }}
          loaderName={'locationUploaderLoading'}
          success={this.success}
          className={cs.spaceTop3}
        />
      </div>
    );
  }
}

const selector = formValueSelector('AddPopularLocation');

const mapState = (state) => ({
  locationUploaderLoading: state.loader.locationUploaderLoading,
  image: selector(state, 'image')
});

const mapDispatch = {
  doRemoveLocation,
  startLocationUploaderLoader,
  endLocationUploaderLoader,
  change,
};

export default compose(injectIntl, withStyles(cs, s), connect(mapState, mapDispatch))(Uploader);